import { requestApi } from '../util/network'

export const getBillList =
(params, other) =>
  requestApi(
    '/o2o_distributor_bill/get_list',
    'POST',
    Object.assign(
      {
          page: params.page,
          per_page: params.per_page,
      },
      other),
    'distributor'
  )

export const confirmBill =
(bill_id, type) =>
  requestApi(
    '/o2o_distributor_bill/confirm_bill',
    'POST',
    {
      bill_id: bill_id,
      type: type
    },
    'distributor'
  )

export const payByCode =
(bill_id, code) =>
  requestApi(
    '/o2o_distributor_bill/pay_by_code',
    'POST',
    {
      bill_id: bill_id,
      code: code
    },
    'distributor'
  )
